import '../sass/plyr.scss';
import '../sprite';

import Plyr from './plyr';

window.Shopify = window.Shopify || {};
window.Shopify.Video = Plyr;
